import {
  getPaginated,
  PaginatedRequest,
  PaginatedResponse,
} from "@/application/api/getPaginated";
import { AxiosPromise } from "axios";

export function mapperAutocomplete(
  data: PaginatedRequest
): AxiosPromise<PaginatedResponse<{ id: number; name: string }[]>> {
  return getPaginated("mapper/autocomplete", data);
}
